import {isObject} from 'ramda-adjunct';

export type CustomFieldCurrency = {
  amount: string;
  currency: string;
};
export const isCurrency = (value: unknown): value is CustomFieldCurrency =>
  isObject(value) && 'amount' in value && 'currency' in value;
